import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, saveSessionToken } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const match = (window.location.hash || "").match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        // Persist session_token in localStorage for Bearer fallback on mobile/strict-cookie browsers
        if (data?.session_token) saveSessionToken(data.session_token);
        setUser(data);
        // Rol'e göre varsayılan landing: pricing_only → /fiyatlandirma, diğerleri → /dashboard
        const dest = data?.role === "pricing_only" ? "/fiyatlandirma" : "/dashboard";
        window.history.replaceState({}, document.title, dest);
        navigate(dest, { replace: true, state: { user: data } });
      } catch (err) {
        const status = err?.response?.status;
        const detail = err?.response?.data?.detail;
        console.warn("[Auth] session exchange failed:", err?.message || err);
        if (status === 403) {
          setError(detail || "Bu e-posta ile giriş izniniz yok.");
          setTimeout(() => navigate("/login", { replace: true }), 4000);
        } else {
          navigate("/login", { replace: true });
        }
      }
    })();
    // Intentionally run once — session_id in URL fragment is single-use and
    // we guard with `processed` ref against StrictMode double invoke.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      {error ? (
        <div className="max-w-sm text-center space-y-3">
          <div className="text-4xl">🚫</div>
          <h1 className="font-display text-2xl font-bold">Erişim Reddedildi</h1>
          <p className="text-sm text-neutral-600">{error}</p>
          <p className="text-xs text-neutral-400">Giriş sayfasına yönlendiriliyorsunuz…</p>
        </div>
      ) : (
        <div className="text-sm label-caps">Kimlik doğrulanıyor…</div>
      )}
    </div>
  );
}
